import React from 'react'
import { mediumDateFormatter } from 'shared/mediumDateFormatter'
import { fullDateFormatter } from 'shared/fullDateFormatter'

type AnyTag = string | React.FC<never>

type MediumDateProps<Tag extends AnyTag> = {
    date: Date
    as?: Tag
} & (Tag extends keyof JSX.IntrinsicElements
    ? JSX.IntrinsicElements[Tag]
    : Tag extends React.ComponentType<infer Props>
    ? Props & JSX.IntrinsicAttributes
    : never)

export default function MediumDate<Tag extends AnyTag = 'span'>({
    date,
    as,
    ...props
}: MediumDateProps<Tag>): React.ReactElement {
    return React.createElement(
        as ?? 'span',
        { title: fullDateFormatter.format(date), ...props } as any,
        [mediumDateFormatter.format(date)],
    )
}
